import { ActionsUnion, createAction } from '@housinganywhere/safe-redux';
import reportError from 'ha/helpers/bugsnag/reportError';
import { GlobalState } from 'ha/types/store';
import { HermesLoadOptions } from 'ha/services/hermes';
import { Thunk } from '../../myredux/types';
import { HermesResponse } from './types';
import { getInfo, getData } from './selectors';

export const enum ActionTypes {
  START = '[hermes] LOAD_START',
  DONE = '[hermes] LOAD_DONE',
  FAIL = '[hermes] LOAD_FAIL',
}

export const Actions = {
  start: () => createAction(ActionTypes.START),
  done: (data: HermesResponse) => createAction(ActionTypes.DONE, data),
  fail: () => createAction(ActionTypes.FAIL),
};

export type Actions = ActionsUnion<typeof Actions>;

export const loadHermesData = (
  pathname: string,
  options: HermesLoadOptions = { includeData: true },
): Thunk<GlobalState> => (dispatch, getState, { hermes }) => {
  const state = getState();
  const info = getInfo(state);

  const infoIsLoaded = info && info.path === pathname;
  const dataIsLoaded = options.includeData ? Boolean(getData(state)) : true;

  if (infoIsLoaded && dataIsLoaded) {
    return Promise.resolve();
  }

  dispatch(Actions.start());

  return hermes
    .load(pathname, options)
    .then(data => {
      dispatch(Actions.done(data));
    })
    .catch(error => {
      if (error && error.code === 404) {
        return;
      }

      dispatch(Actions.fail());
      reportError('loadHermesData failed', { metaData: error });
    });
};
